import React, { useState } from 'react'
import { ForgetPasswordForm } from '../components/auth/forget_password_form'
import { axiosPost } from '../util/api'
import { Toasts } from '../components/toaster/Toast'

export const ForgotPassword = () => {
    const [loading, setLoading] = useState(false)

    const reset = (email: string) => {
        setLoading(true)
        axiosPost(
            'password/email',
            {
                email,
            },
            true,
        )
            .then(() => {
                setLoading(false)
                Toasts.success('Reset link successfully sent')
            })
            .catch((res) => {
                setLoading(false)
                console.log(res)
            })
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <ForgetPasswordForm onSubmit={reset} loading={loading} />
        </div>
    )
}
